import { render } from "./ConfigDocumentation.vue?vue&type=template&id=d476bf30"
import script from "./ConfigDocumentation.vue?vue&type=script&lang=js"
export * from "./ConfigDocumentation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Development\\Canvas\\Certificate\\Certificate.Web\\vue-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
